import {create} from "zustand";
import {derivedRemoteStore} from "./DerivedStore";
import {Employee, EmployeeRef} from "./Model";
import {associateBy} from "../util/MapUtil";
import {useEmployeeStore} from "./EmployeeStore";
import {idFn} from "../util/FunctionUtil";

export class EmployeeMap {
    private readonly employeeMap: Map<EmployeeRef['id'], Employee>;
    private readonly employeeMapByEmail: Map<Employee['email'], Employee>;

    constructor(employees: Employee[]) {
        this.employeeMap = associateBy<Employee, EmployeeRef['id']>(employees, idFn);
        this.employeeMapByEmail = associateBy<Employee, Employee['email']>(
            employees.filter(employee => employee.email),
            employee => employee.email.toLowerCase(),
        );
    }


    get(employee: EmployeeRef): Employee | undefined {
        return this.getById(employee.id);
    }

    getById(employeeId: EmployeeRef['id']): Employee | undefined {
        return this.employeeMap.get(employeeId);
    }

    getByEmail(email: Employee['email']): Employee | undefined {
        return this.employeeMapByEmail.get(email.toLowerCase());
    }

    get length(): number {
        return this.employeeMap.size;
    }

    static EMPTY = new EmployeeMap([]);
}

export const useEmployeeMapStore = create(
    derivedRemoteStore(
        {employees: useEmployeeStore},
        ({employees}) => {
            return new EmployeeMap(employees);
        },
    )
);